{{#if config.label}}
  {{> elements/_page_builder_label label=config.label description=config.description }}
{{/if}}
<div>
  <div class="slideshow-editor-container">
    {{#each context.slides}}
      <div class="slideshow-editor-slide">
        {{#if isVideo}}
          <video src="{{ url }}"></video>
        {{else}}
          <img src="{{ url }}" alt="{{ alt }}" />
        {{/if}}
        <span class="slideshow-editor-slide-remove" data-slideshow-editor-behaviour="remove-slide" data-slide-index="{{@key}}">✕</span>
      </div>
    {{/each}}
    <div class="slideshow-editor-slide slideshow-editor-slide-add" data-slideshow-editor-behaviour="add-slide">
      {{{ icon 'add' }}}
      {{{ icon 'image' }}}
    </div>
    <div class="slideshow-editor-slide slideshow-editor-slide-add" data-slideshow-editor-behaviour="add-slide-video">
      {{{ icon 'add' }}}
      {{{ icon 'video' }}}
    </div>
  </div>
  <small class="tool-comment">Click a Slide to Edit. Drag & Drop to Reorganize.</small>
</div>
<div class="customized shared-component-options">
  <a href="" class="reset">{{{ icon "close-alt-color" }}} Remove Override</a>
</div>
